import { useHistory } from 'react-router-dom'
import { useDetailLinkBase } from './useDetailLinkBase'
import type { MediaLibrarySearchFileResponse } from '../interfaces'
import { useCallback } from 'react'

type NavigateOpts = {
    mediaCollectionRoute?: boolean
    currentMediaCollection?: string
    file: MediaLibrarySearchFileResponse
}

export function useNavigateToDetail() {
    const history = useHistory()
    const { background } = useDetailLinkBase()

    return useCallback(({ mediaCollectionRoute, currentMediaCollection, file }: NavigateOpts) => {
        const { type, fileId, versionInfo } = file
        if (window.isMediaLibraryWidget) {
            if (mediaCollectionRoute) {
                if (type === 'file-version') {
                    history.push({
                        pathname: `/media-collections/${currentMediaCollection}/detail/${fileId}/${versionInfo.id}`,
                        search: `?widgetHost=${window.widgetHost}${window.widgetImagekitId
                            ? `&widgetImagekitId=${window.widgetImagekitId}`
                            : ''
                            }`,
                        state: { background },
                    })
                } else {
                    history.push({
                        pathname: `/media-collections/${currentMediaCollection}/detail/${fileId}`,
                        search: `?widgetHost=${window.widgetHost}${window.widgetImagekitId
                            ? `&widgetImagekitId=${window.widgetImagekitId}`
                            : ''
                            }`,
                        state: { background },
                    })
                }
            } else if (type === 'file-version') {
                history.push({
                    pathname: `/media-library/detail/${fileId}/${versionInfo.id}`,
                    search: `?widgetHost=${window.widgetHost}${window.widgetImagekitId
                        ? `&widgetImagekitId=${window.widgetImagekitId}`
                        : ''
                        }`,
                    state: { background },
                })
            } else {
                history.push({
                    pathname: `/media-library/detail/${fileId}`,
                    search: `?widgetHost=${window.widgetHost}${window.widgetImagekitId
                        ? `&widgetImagekitId=${window.widgetImagekitId}`
                        : ''
                        }`,
                    state: { background },
                })
            }
        } else if (mediaCollectionRoute) {
            if (type === 'file-version') {
                history.push({
                    pathname: `/media-collections/${currentMediaCollection}/detail/${fileId}/${versionInfo.id}`,
                    state: { background },
                })
            } else {
                history.push({
                    pathname: `/media-collections/${currentMediaCollection}/detail/${fileId}`,
                    state: { background },
                })
            }
        } else if (type === 'file-version') {
            history.push({
                pathname: `/media-library/detail/${fileId}/${versionInfo.id}`,
                state: { background },
            })
        } else {
            history.push({
                pathname: `/media-library/detail/${fileId}`,
                state: { background },
            })
        }
    }, [history, JSON.stringify(background)])
}